import { StrategyPage, Strategies } from './';

export default {
  path: 'strategies',
  childRoutes: [
    { path: ':tokenId/:strategyId', component: StrategyPage, isIndex: false },
    { path: ':tokenId/:strategyId/:vaultId', component: StrategyPage, isIndex: false },
    { path: '', component: Strategies, isIndex: true }
  ]
};